import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@root/src/environments/environment';
import { Observable } from 'rxjs';
import {
  ExternalSceneLoadRequest,
  ExternalSceneLoadResponse,
  ExternalScenesSearchRequest,
  ExternalScenesSearchResponse
} from './external-scenes.models';

/**
 * Facade over `/satellite/ExternalScenes/*`.
 *
 * TODO: migrate to api-client. Documented exception to the "generated client only" rule: the installed
 * `@6grain/masofa-monolith-api-client` has no `ExternalScenes` service yet. Remove this class (and the
 * models it uses that the client generates) once the client is regenerated and updated.
 *
 * Both calls are POST, so unsubscribing cancels only the browser request; the caller decides when to do it.
 */
@Injectable({ providedIn: 'root' })
export class ExternalScenesApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.api}/satellite/ExternalScenes`;

  /** Read-only search of provider scenes; writes nothing to the local catalog. */
  search(request: ExternalScenesSearchRequest): Observable<ExternalScenesSearchResponse> {
    // TODO: migrate to api-client (endpoint absent from the installed generated client).
    return this.http.post<ExternalScenesSearchResponse>(`${this.baseUrl}/Search`, request);
  }

  /** Writes the scene into SatelliteProducts and starts `satellite.download-product`. */
  load(request: ExternalSceneLoadRequest): Observable<ExternalSceneLoadResponse> {
    // TODO: migrate to api-client (endpoint absent from the installed generated client).
    return this.http.post<ExternalSceneLoadResponse>(`${this.baseUrl}/Load`, request);
  }
}
